import { Id, toast } from "react-toastify";

export function toastSuccess(_toast: Id, render: string) {
  return toast.update(
    _toast,
    {
      render,
      type: 'success',
      isLoading: false,
      autoClose: 2500
    }
  )
}

// autoClose: loading toasts don't close by themselves, so without it the error stays until it's clicked
export function toastError(_toast: Id, render: string, autoClose?: number) {
  return toast.update(
    _toast,
    {
      render,
      type: 'error',
      isLoading: false,
      ...(autoClose ? { autoClose } : {})
    }
  )
}

export function toastWarning(_toast: Id, render: string) {
  return toast.update(
    _toast,
    {
      render,
      type: 'warning',
      isLoading: false,
      autoClose: 2500
    }
  )
}